import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AUTH_ROUTES } from "@app-auth/auth.routes";
import { NotFoundComponent } from "@app-shared/pages/not-found/not-found.component";

import { AuthGuard } from "./auth/guards/auth.guard";
import { DistributorGuard } from "./distributor/guards/distributor.guard";

const appRoutes: Routes = [
  ...AUTH_ROUTES,
  {
    path: "admin",
    canMatch: [AuthGuard],
    loadChildren: () => import("./core/core.routes").then((m) => m.CORE_ROUTES),

    data: {
      role: "ADMIN",
    },
  },
  {
    path: "distributor",
    canMatch: [AuthGuard, DistributorGuard],
    loadChildren: () => import("./distributor/distributor.routes").then(
      (m) => m.DISTRIBUTOR_ROUTES
    ),

    data: {
      role: "DISTRIBUTOR",
    },
  },

  {
    path: "quality",
    // To be implemented
    canMatch: [],
    loadChildren: () => import("./quality/routes/quality.routes").then((m) => m.QUALITY_ROUTES),

    data: {
      role: "",
    },
  },

  { path: "**", component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
